import { lazy } from 'react';

const Dashboard = lazy(() => import('../../admin/dashboard/AdminDashboardPage'));

const ManagerDashboardConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'manager/dashboard',
      element: <Dashboard />,
    },
  ],
};

export default ManagerDashboardConfig;
